// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 3H23V21H13V20.0039C13 13.9288 8.07513 9.00391 2 9.00391H1.00391L1 9V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 11H2C6.97056 11 11 15.0294 11 20V21H9V20C9 16.134 5.86599 13 2 13H1V11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 15H2C4.76142 15 7 17.2386 7 20V21H5V20C5 18.3431 3.65685 17 2 17H1V15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.00391 19H1V21.0039H3.00391V19Z"}}]};

const CastFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cast-filled',
    ref,
    icon: element,
  },
));

CastFilledIcon.displayName = 'CastFilledIcon';

export default CastFilledIcon;
